<div fxLayout="row" fxLayoutAlign="end end" class="hierarchy" (mouseenter)="hierarchy.open()">
  <mat-form-field appearance="fill">
    <mat-label>Hierarchy</mat-label>
    <mat-select #hierarchy (selectionChange)="changeHierarchy($event)" [(value)]="selectedHierarchy">
      <mat-option *ngFor="let item of hierarchyList" [value]="item" >
        <span>{{item.attributes.name | textCorrection}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>